module.exports = __webpack_public_path__ + "img/zs3.1de81f44.jpg";